import { useMutation, useQueryClient } from '@tanstack/react-query'
import classNames from 'classnames'
import React, { useCallback, useState } from 'react'
import { BiCheck } from 'react-icons/bi'

import { ddPanelMainAccountAPI } from '../../../api/services/dd_panel_main_accounts'
import { SubAccount } from '../../../api/services/dd_panel_sub_accounts/types.ts'

const ToggleSurvey = ({ row }: { row: SubAccount }) => {
  const queryClient = useQueryClient()
  const [checked, setChecked] = useState(row.surveys_enabled)

  const toggleSurveysEnabled = async () => {
    try {
      const results = await ddPanelMainAccountAPI.toggleSurveys(row.id)
      if (results.status === 200) setChecked(!checked)
    } catch (error) {
      console.log('toggleSurveysEnabled error', error)
    }
  }

  const { mutateAsync } = useMutation({
    mutationFn: toggleSurveysEnabled,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['subAccounts'] })
    }
  })

  const checkboxClass = classNames(
    'relative flex w-6 h-6 border-4 dark:border-gray-700 dark:bg-gray-600 rounded-md justify-center items-center',
    { 'cursor-pointer': true }
  )

  const handleClick = useCallback(async () => {
    await mutateAsync()
  }, [mutateAsync])

  return (
    <div
      className="flex justify-center items-center h-full w-full"
      onClick={handleClick}
    >
      <div className={checkboxClass}>
        {checked && (
          <BiCheck
            className="text-green-500 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 scale-150"
            size={22}
          />
        )}
      </div>
    </div>
  )
}
export default ToggleSurvey
